/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

export type Method = 'GET' | 'POST'

export class SiteProxy {
  private static readonly mProxy = new SiteProxy()
  // window.location.origin
  static getInstance(): SiteProxy {
    return SiteProxy.mProxy
  }

  public readonly siteEndpoint: string =
    process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:1380'

  public async sendRequest(method: Method, path: string, json?: any) {
    const fullUrl = this.siteEndpoint + path
    console.log(`Sending ${method.toUpperCase()} request to: ${fullUrl} with data:`, json)
    if (!json) json = {}
    return await axios({
      method,
      url: this.siteEndpoint + path,
      timeout: 60000, //default 50000
      data: json,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((result: any) => {
        return result
      })
      .catch(err => {
        console.error(err)
        throw err
      })
  }
}
